import CustomOrders from "../customOrders/CustomOrders";
import Hero from "../hero/Hero";
//import NewsSection from "../newsSection/NewsSection";

import "./HomePage.css";

export default function HomePage() {
    return (
        <main className="homePage">
            <Hero />
            {/* <NewsSection /> */}
            <CustomOrders />
        </main>
    )
}